export default __webpack_public_path__ + "76a61aa061ba0c535015807a3f5a7235.svg";